import React, { FC } from 'react';

import { useUser } from '@adsk/alloy-provider';

import { AnalyticsInitializer } from './AnalyticsInitializer';

export const AuthenticatedAnalyticsInitializer: FC = () => {
  const { user } = useUser();

  if (!user) {
    return null;
  }

  return <AnalyticsInitializer />;
};
